__webpack_require__.hmrF = () => ("Donations." + __webpack_require__.h() + ".hot-update.json");